/**
 * Tier gating is fully disabled.
 * All tools are considered accessible; legacy Scale/Enterprise/Accelerate plans are no longer used.
 */
export function useTierGate() {
  return {
    hasAccess: true,
    isLocked: false,
    requiredTier: null,
    signedIn: true,
    plan: null,
  };
}

export default useTierGate;
